import { IReCaptchaProps } from "./ReCaptcha.types";
import React from "react";
import ReCaptchaView from "./ReCaptcha.view";

const ReCaptchaContainer: React.FC<IReCaptchaProps> = ({
  onExpire,
  onSuccess,
  reCaptchaRef,
  sitekey
}) => (
  <ReCaptchaView
    onChange={token => {
      if (token === null) {
        if (onExpire) {
          onExpire();
        }
      } else {
        onSuccess(token);
      }
    }}
    reCaptchaRef={reCaptchaRef}
    siteKey={sitekey}
  />
);

export default ReCaptchaContainer;
